<template>
	<div class="form-info">
		<div class="info-panel row" ref="infoPanel">
			<p class="col-sm-12 title">{{ this.$t('form-additional-info') }}</p>
			<div v-for="(item, index) in items" :key="index" class="col-sm-12 col-md-6 col-lg-4">
				<div class="form-group d-flex">
					<label class="col-form-label pl-0 pr-0">{{ item[0] }}:</label>
					<div class="">
						<div class="p-2" v-if="item[2] === 'date'">{{ getDate(item[1]) }}</div>
						<div class="p-2 ltr" v-if="item[2] === 'datetime'">{{ getDateTime(item[1]) }}</div>
						<div class="p-2" v-if="!item[2] || item[2] === 'string'">{{ String(item[1]).toLocaleDigits() }}</div>
					</div>
				</div>
			</div>
			<div class="hide" @click="onHandlerClick"><i class="fa fa-chevron-double-up"></i></div>
		</div>
		<i class="fa fa-info handler" @click="onHandlerClick"></i>
	</div>
</template>
<script>
	import $ from 'jquery'
	import _ from 'lodash'
	import PersianDate from 'persian-date'

	export default {
		name: 'form-info',
		props: {
			data: {},
			options: {}
		},
		data() {
			return {
				items: []
			}
		},
		watch: {
			data: {
				deep: true,
				handler(value, oldValue) {
					this.items = value
				}
			}
		},
		computed: {
			hasHint() {
				return !!this.$slots['hint']
			},
			hasLabel() {
				return (this.label && this.label.length)
			}
		},
		methods: {
			onFocus() {
				$(this.$refs.element).children().focus()
			},
			onHandlerClick() {
				const $panel = $(this.$refs.infoPanel)
				if ($panel.is(':visible')) {
					$panel.slideUp()
				} else {
					$panel.css('display', 'flex').hide().slideDown()
				}
			},
			getDateTime(gdate) {
				if (gdate) {
					let date = new Date(gdate)
					date = new PersianDate(date)
					return date.format('YYYY/MM/DD HH:mm:ss')
				}
				return ''
			},
			getDate(gdate) {
				if (gdate) {
					let date = new Date(gdate)
					date = new PersianDate(date)
					return date.format('YYYY-MM-DD')
				}
				return ''
			}
		}
	}
</script>
<style scoped>
	.info-panel {
		display: none;
	}
</style>
